module.exports = __webpack_public_path__ + "img/facilita-marketplace-icon-branco.cf9af0d5.svg";